import React, { useEffect } from "react";
import ResetForm from "./ResetForm";

function PasswordResetPage() {
  
  useEffect(() => {
    console.log("Full URL:", window.location.href);
    
    const params = new URLSearchParams(window.location.search);
    console.log("Token:", params.get("token"));
    console.log("UUID:", params.get("uuid"));
  }, []);

  return <ResetForm />;
}

export default PasswordResetPage;